import DialogComponent from '../widgets/dialog/DialogComponent';

class PrintDescriptionDialog extends DialogComponent {

  state = {
    value: ''
  }

  render() {
    return (
      <div className="col-12">
        <textarea
          rows={5}
          className="form-control"
          onChange={(e) => this.setState({ value: e.target.value })}
          placeholder='در صورتی که میخواهید متنی را زیر گراف بنویسید از در این کادر نوشته و سپس روی دکمه پرینت کلیک کنید'
          ></textarea>
        <button className="btn btn-block btn-primary mt-3" onClick={this.handleSubmit}>پرینت</button>
      </div>
    );
  }

  handleSubmit = () => {
    this.close(this.state.value);
  }

}

export default PrintDescriptionDialog;
